var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back-arrow"},[_c('span',{on:{"click":function($event){return this.$router.back();}}},[_vm._v("←")])])}
var staticRenderFns = []

export { render, staticRenderFns }